import React from "react";
import { useRef, useState, useEffect } from "react";
import "./DappProcess.css";
import process1 from "../decentassets/process1.png";
import process2 from "../decentassets/process2.png";
import process3 from "../decentassets/process3.png";
import process4 from "../decentassets/process4.png";
import process5 from "../decentassets/process5.png";

const processCards = [
  {
    id: 1,
    image: process1,
    title: "Multi-Blockchain Deployment",
    description:
      "Applications are designed to operate across multiple blockchain networks, allowing greater flexibility in choosing the right chain for specific performance and cost needs.",
  },
  {
    id: 2,
    image: process2,
   title: "Optimized Performance and Costs",
    description:
      "Different blockchains can be leveraged to improve transaction speed, reduce gas fees, and maintain efficient scalability as usage grows.",
  },
  {
    id: 3,
    image: process3,
    title: "Reduced Network Dependency",
    description:
      "Reliance on a single blockchain is minimized, lowering risks related to congestion, outages, or ecosystem limitations.",
  },
  {
    id: 4,
    image: process4,
    title: "Future-Ready Expansion",
    description:
      "Architecture supports easy integration with new blockchain networks, ensuring long-term adaptability and growth within evolving Web3 ecosystems.",
  },
  {
    id: 5,
    image: process5,
   title: "Network-Independent Asset Design",
    description:
      "Assets are created to remain functional across evolving blockchain environments, protecting long-term value and usability.",
  },
  // {
  //   id: 6,
  //   image: process6,
  //   title: "Technical Design",
  //   description:
  //     "We deploy your PWA, configure analytics, monitor service worker updates, and fine-tune caching, asset delivery, and UI responsiveness based on real user performance data.",
  // },
];

export default function DappProcess() {   
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollContainerRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const getVisibleCount = () => {
  if (!scrollContainerRef.current) return 1;
  const containerWidth = scrollContainerRef.current.clientWidth;
  const cardWidth = getCardScrollWidth();
  return Math.max(1, Math.round(containerWidth / cardWidth));
};

 const checkScroll = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 10);

      const cardScrollWidth = getCardScrollWidth();
      if (cardScrollWidth > 0) {
        setActiveIndex(Math.round(scrollLeft / cardScrollWidth));
      }
    }
  };

  useEffect(() => {
    checkScroll();
    const container = scrollContainerRef.current;
    if (container) {
      container.addEventListener("scroll", checkScroll);
      window.addEventListener("resize", checkScroll);
      return () => {
        container.removeEventListener("scroll", checkScroll);
        window.removeEventListener("resize", checkScroll);
      };
    }
  }, []);

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const scrollAmount = 450;
      const newScrollLeft =
        direction === "left"
          ? scrollContainerRef.current.scrollLeft - scrollAmount
          : scrollContainerRef.current.scrollLeft + scrollAmount;

      scrollContainerRef.current.scrollTo({
        left: newScrollLeft,
        behavior: "smooth",
      });
    }
  };

  const getCardScrollWidth = () => {
    if (!scrollContainerRef.current) return 0;
    const card = scrollContainerRef.current.querySelector(".card");
    if (!card) return 0;

    const gap = 24;
    return card.offsetWidth + gap;
  };

  return (
    <div id="dapp-process">
      <div className="top">
   <div className="left">
          <h2 className="heading">
     Build dApps Across Multiple Blockchains Without Vendor Lock-In
    </h2>
          <p className="subheading">
Multi-chain dApp development delivers flexibility, performance optimization, and long-term scalability across blockchain networks. </p>
   </div>
   <div className="right">
    <button>Get in touch</button>
   </div>
    </div>

      <div className="slider-wrapper">
        {canScrollLeft && (
          <button
            onClick={() => scroll("left")}
            className="scroll-button scroll-button-left"
          >
            ←
          </button>
        )}

        <div
          ref={scrollContainerRef}
          className={`cards-container ${!canScrollLeft ? "padding-left" : ""} ${
            !canScrollRight ? "padding-right" : ""
          }`}
        >
          {processCards.map((card) => (
            <div key={card.id} className="card" style={{background:card.bg}}>
              <div className="card-container-main">
                   <img src={card.image} alt={card.title} className="card-image" />
                <h2 className="card-title">{card.title}</h2>
                <p className="card-description">{card.description}</p>
              </div>
  </div>
          ))}
        </div>

        {canScrollRight && (
          <button
            onClick={() => scroll("right")}
            className="scroll-button scroll-button-right"
          >
            →
          </button>
        )}
      </div>
      <div className="custom-dots">
      {Array.from({ length: processCards.length - getVisibleCount() + 1 }).map((_, index) => (
  <button
    key={index}
    className={`dot ${index === activeIndex ? "active" : ""}`}
    onClick={() => {
      scrollContainerRef.current?.scrollTo({
        left: index * getCardScrollWidth(),
        behavior: "smooth",
      });
    }}
  />
))}
      </div>
    </div>
  );
}
